<template>
    <div class="login">
        <div class="center">
            <div class="box" style="width:34%;float: left;margin-right: 8%;height: 80%">
                <img :src="logoSrc" style="padding: 10px">
            </div>
            <div class="box" style="width:34%;float: right;margin-right: 8%;height: 80%;margin-top: 4%;">
                <header class="title">
                    <p>专升本信息管理系统</p>
                </header>
                <transition  appear appear-active-class="box-active-class" >
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="学生登录" name="first" >
                            <div >
                                <el-form :model="studentForm" :rules="studentRules" style="margin-top: -10px" ref="studentForm" @keyup.enter.native="studentLogin">
                                    <el-form-item prop="idCard">
                                        <el-input placeholder="请输入身份证号" class="input" v-model="studentForm.idCard">
                                            <i slot="prefix" class="iconfont icon-businesscard_fill" style="color: #52C5FB;font-size: 28px;margin-left: 15px"></i>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item prop="pwd">
                                        <el-input  :type="pwdType" placeholder="请输入密码(初始登录密码为身份证后四位)" v-model="studentForm.pwd">
                                            <i slot="prefix" class="iconfont icon-denglu-mima" style="color: #52C5FB;margin-left: 15px"></i>
                                            <i slot="suffix" :class="pwdType==='text'? 'icon-zhengyan iconfont':'icon-biyan iconfont'" @click="pwdType = pwdType==='password'?'text':'password'"></i>
                                        </el-input>
                                    </el-form-item>
                                    <div class="login-btn-group">
                                        <el-button style="width:100%;" type="common" @click="studentLogin">登录</el-button>
                                    </div>
                                    <div style="height: 28px;line-height: 28px;font-size: 14px;" v-show="activeName=='first'">
                                        <span>
                                            <el-tooltip class="item" effect="dark" content="请联系学院电话027-87934566，重置密码" placement="bottom">
                                                <el-button type="text" size="mini" style="float: left;color: #ccc;;margin-left: 10px;">忘记密码</el-button>
                                            </el-tooltip>
                                        </span>
                                        <span type="text" class="table-edit" style="float: right;color: #fff;margin-right: 10px"   v-if="timeForm.status=='0'" >
                                            <el-tooltip class="item" effect="dark" v-if="checkTime" content="点我开始注册报名" placement="bottom">
                                                <el-button size="mini" type="text" style="color: red;font-weight: bold;font-size: 18px" @click="goRegist">注册报名</el-button>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="dark" v-else :content="'报名时间为：'+registTime+'。如有疑问请联系学院老师'" placement="bottom">
                                                <el-button size="mini" type="text" style="color: #ccc">注册报名</el-button>
                                            </el-tooltip>
                                        </span>
                                    </div>
                                </el-form>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="教师登录" name="second" >
                            <div >
                                <el-form :model="ruleForm" :rules="rules" style="margin-top: -10px" ref="ruleForm" @keyup.enter.native="login">
                                    <el-form-item prop="username">
                                        <el-input placeholder="手机号" v-model="ruleForm.username">
                                            <i slot="prefix" class="iconfont icon-mobilephone_fill" style="color: #52C5FB;font-size: 28px;margin-left: 15px"></i>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item prop="pwd">
                                        <el-input :type="pwdType" placeholder="密码" v-model="ruleForm.pwd">
                                            <i slot="prefix" class="iconfont icon-denglu-mima" style="color: #52C5FB;margin-left: 15px"></i>
                                            <i slot="suffix" :class="pwdType==='text'? 'icon-zhengyan iconfont':'icon-biyan iconfont'" @click="pwdType = pwdType==='password'?'text':'password'"></i>
                                        </el-input>
                                    </el-form-item>
                                    <div class="login-btn-group">
                                        <el-button style="width:100%;" type="common" @click="login('ruleForm')">登录</el-button>
                                    </div>
                                </el-form>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="学生手机报名扫码" name="three" >
                            <div style="height: 292px;text-align: center;margin: auto">
                                <img :src="mobileSrc" style="height: 252px"/>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </transition>
            </div>
        </div>
        <div style="height: 60px;position: absolute;top: 85%;width: 100%;text-align: center;margin: auto">
            <img src="../../assets/frame/images/bz.png" style="width: 60%" >
        </div>
        <div class="page-bottom" style="text-align: center;color: #fff">
            <p class="footer-copy" >©2020~{{new Date().getFullYear()}} <a href="http://www.qcuwh.cn/" class="edit" style="color: #fff" target="_blank">武汉晴川学院</a> 版权所有</p>
        </div>
        <el-dialog :close-on-click-modal="false" :show-close="false" width="1000px" :visible.sync="lookVisible">
            <template v-slot:title>
                考生须知
            </template>
            <div style="margin-top: -50px" v-html="loginRemarkCode.remark">

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" class="large" @click="lookVisible = false" :disabled="disabled">{{ btnText }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import md5 from 'md5';
    import {Decrypt,Encrypt} from '@/util/cryptojs';
    export default {
        name: 'login',
        data () {
            return {
                config:config,
                activeName: 'first',
                logoSrc: require('../../assets/logo.png'),
                mobileSrc:require('../../assets/mobile.png'),
                ruleForm:{
                    username:'',
                    pwd:'',
                },
                pwdType: 'password',
                rules:{
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                        { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
                    ],
                    pwd: [
                        { required: true, message: '请填写密码', trigger: 'blur' }
                    ]
                },
                studentForm:{
                    idCard:'',
                    pwd:'',
                },
                studentRules:{
                    idCard: [
                        { required: true, message: '请输入身份证号', trigger: 'blur' },
                        { min: 18, max: 18, message: '长度为18个字符', trigger: 'blur' }
                    ],
                    pwd: [
                        { required: true, message: '请填写密码', trigger: 'blur' }
                    ]
                },
                registTime:'',
                checkTime:'',
                timeForm:{

                },
                lookVisible:false,
                disabled: false,
                interval:undefined,
                totalCount:0,
                loginRemarkCode:{}
            };
        },
        created(){
            var widthClient = document.body.clientWidth;
            if(!widthClient || parseInt(widthClient)<1050){
                location.href="http://120.202.180.67:8087";
            }else{
                axios({
                    url:`${home}/login/checkRegistTime`,
                    method:'GET'
                }).then(res=>{
                    if(res.data && res.data2){
                        this.timeForm = res.data;
                        this.checkTime = res.data2;
                    }
                }).catch(error=>{

                });
            }
            this.getLoginRemarkCodeList();
        },
        mounted(){
        },
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
            },
            login() {
                this.$refs['ruleForm'].validate((valid) => {
                    if(!valid){
                        this.$message.error('请填写符合规范的用户名和密码');
                        return;
                    }
                    axios({
                        url:`${home}/login/login`,
                        method:'POST',
                        data:{
                            username:this.ruleForm.username,
                            password:md5(this.ruleForm.pwd),
                            token:''
                        },
                        diy:true
                    }).then(res=>{
                        if(!res.result.success){
                            this.ruleForm.tel='';
                            this.ruleForm.pwd='';
                            this.$message.error(res.result.msg);
                            return;
                        }
                        this.$store.commit('setToken',res.data);
                        this.$store.commit('setPerms',res.data2);
                        this.$router.push('/index');
                    })
                });
            },
            studentLogin() {
                this.$refs['studentForm'].validate((valid) => {
                    if(!valid){
                        this.$message.error('请填写符合规范的身份证号和密码');
                        return;
                    }
                    axios({
                        url:`${home}/login/studentLogin`,
                        method:'POST',
                        data:{
                            idCard:this.studentForm.idCard,
                            password:md5(this.studentForm.pwd),
                            token:''
                        },
                        diy:true
                    }).then(res=>{
                        if(!res.result.success){
                            this.ruleForm.pwd='';
                            this.$message.error(res.result.msg);
                            return;
                        }
                        this.$store.commit('setToken',res.data);
                        this.$store.commit('setPerms',res.data2);
                        this.$router.push('/studentIndex');
                    })
                });
            },
            goForget(){
                this.$router.push('/forgetpassword');
            },
            goRegist(){
                this.$router.push('/regist');
            },
            downLoad(){
                window.open(config.resPre+this.url);
            },
            showMsg(){
                this.lookVisible = true;
            },
            getLoginRemarkCodeList(){
                axios({
                    url:`${home}/sysDdList/getLoginRemarkCodeList`,
                    method:'GET',
                }).then(res=>{
                    if(res.data2=='1'){
                        this.lookVisible = true;
                        this.loginRemarkCode = res.data;
                        this.disabled=true;
                        this.totalCount=10;
                        this.interval=setInterval(()=>{
                            this.totalCount--
                            if(this.totalCount === 0){
                                clearInterval(this.interval)
                                this.disabled=false
                            }
                        },1000);
                    }else{
                        this.lookVisible = false;
                    }
                })

            }

        },
        computed: {
            btnText(){
                return this.totalCount !==0? `阅读${this.totalCount}考生须知`: "我已阅读考生须知"
            }
        },
    }
</script>
<style>
    /*vaptach验证码*/
    .vp-basic-btn{
        height: 43px !important;
    }
    .vaptcha-init-main {
        display: table;
        width: 100%;
        height: 100%;
        background-color: #eeeeee;
    }

    .vaptcha-init-loading {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .vaptcha-init-loading>a {
        display: inline-block;
        width: 18px;
        height: 18px;
        border: none;
    }

    .vaptcha-init-loading>a img {
        vertical-align: middle;
    }

    .vaptcha-init-loading .vaptcha-text {
        font-family: sans-serif;
        font-size: 12px;
        color: #cccccc;
        vertical-align: middle;
    }

    .vp-tip {
        line-height: 43px !important;
    }

    .vp-dark-btn.vp-basic-btn {
        max-height: 43px !important;
    }

    .vp-dark-btn.vp-basic-btn .vp-shield {
        width: 70px !important;
        background-color: rgba(0, 0, 0, 0.1) !important;
    }

    .vp-dark-btn.vp-success-btn.success-ing .vp-shield .vp-shade {
        display: none;
    }

    .vp-dark-btn.vp-basic-btn .vp-factor-chart {
        margin-left: 23px !important;
    }

    .vp-dark-btn.vp-success-btn .vp-shield .vp-chart-ring i {
        left: 28px !important;
    }

    .vp-dark-btn.vp-check-btn,
    .vp-dark-btn.vp-fail-btn,
    .vp-dark-btn.vp-low-btn,
    .vp-dark-btn.vp-tip-btn,
    .vp-dark-btn.vp-success-btn,
    .vp-light-btn.vp-default-btn .vp-shield,
    .vp-light-btn.vp-default-btn .vp-about {
        background-color: #00D59F !important;
        border-radius: 30px !important;
    }

    .vp-dark-btn.vp-basic-btn .vp-tip {
        font-size: 16px !important;
        text-indent: 66px !important;
    }

    .vp-dark-btn.vp-tip-btn .vp-tip{
        text-indent: 26px !important;
    }

    .vp-dark-btn.vp-success-btn .vp-tip{
        text-indent: 20px !important;
    }

    .vp-dark-btn.success-ing .vp-tip{
        text-indent: 98px !important;
    }


    .vp-dark-btn.fail-ing .vp-tip{
        text-indent: 92px !important;
    }

    .vp-about {
        display: none !important;
    }

    .vaptcha-init-main {
        border-radius: 30px !important;
    }

    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
    }

    .vp-dark-btn.vp-success-btn .vp-btn-bg{
        background: #0097e8 !important;
    }

    .login .el-form-item__error {
        text-indent: 60px !important;
    }
</style>
<style scoped lang="scss">
    .login {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background: url(../../assets/frame/images/bg.png) no-repeat;
        background-size: cover;

        .center {
            position: absolute;
            top: 48%;
            right: 13%;
            width: 74%;
            height: 72%;
            background: url(../../assets/frame/images/bg_center.png) no-repeat;
            background-size: cover;
            border-radius: 5px;
            z-index: 2;
            transform: translate(0, -50%);

            /deep/ .el-button--common {
                height: 43px;
                border-color: #52C5FB;
                border-radius: 30px;
                color: #fff;
                font-size: 18px;
                background: #0088D0;
                transition: all .3s;
                border-color: #0088D0;
                &:hover {
                    background: #0097E8;
                }
            }
        }
    }

    .logo {
        display: inline-block;
        margin: 65px 0 0 30px;
        height: 60px;
    }

    .login-btn-group {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .el-input {
        width: 100%;
    }
    .box {
        box-sizing: border-box;
        width: 100%;
        .iconfont {
            display: block;
            width: 22px;
            height: 100%;
            font-size: 24px;
            color: #A6A6A6;
        }
        .icon-zhengyan,
        .icon-biyan {
            margin-right: 24px;
            font-size: 16px;
        }

        .icon-biyan {
            transform: scale(0.94);
            font-size: 12px;
        }
    }

    .box-active-class {
        animation: box-in 1.2s;
    }

    @keyframes box-in {
        0% {
            transform: translateX(150px);
        }

        100% {
            transform: translateX(0);
        }
    }

    .title {
        p {
            margin-bottom: 20px;
            letter-spacing: 2.4px;
            color: #7DB1FF;
            font-size: 28px;
            font-style: normal;
            font-weight: bold;
            text-align: center;
        }
    }

    .el-form {
        margin-top: 43px;
    }

    .el-form-item {
        margin-top: 13px;

        /deep/ .el-input__inner {
            border: solid 1px #E4E7ED;
            border-radius: 10px;
        }

        /deep/ .vp-dark-btn.vp-default-btn {
            //background: linear-gradient(to right, #24c660, #05a278);
            background: #0097e8;
            border-radius: 30px;
        }

        /deep/ .el-form-item__content {
            line-height: 50px;

            .el-input__inner {
                position: relative;
                padding-left: 60px;
                height: 43px;
                line-height: 43px;
            }

            .el-input {
                &:after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 1px;
                    //border-bottom: 1px solid #E0E0E0;
                    opacity: 0.5;
                }
            }

        }
    }

    #vaptcha_container {
        margin-top: 30px;
    }
    #vaptcha_container1 {
        margin-top: 30px;
    }
    .page-bottom {
        position: absolute;
        margin: 0;
        padding: 0;
        right: 45%;
        bottom: 5px;
        font-size: 12px;
        text-align: center;
        color: #999;
    }
    .edit{
        font-size: 12px;
        text-decoration: none;
        cursor: pointer;
        color: #999;
    }
</style>
<style lang="scss">
    .login{
        .el-form-item[data-v-f85286c6] .el-form-item__content .el-input:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 0px;
            border-bottom: 0px solid #E0E0E0;
            opacity: 0.5;
        }
        .el-tabs__item:hover {
            color: #7DB1FF;
            cursor: pointer;
        }
        .el-tabs__item.is-active {
            color: #7DB1FF;
            font-size: 16px;
        }
        .el-tabs__active-bar {
            height: 4px;
            background-color: #7DB1FF;
        }
    }
    .xz{
        div{
            line-height: 24px;
        }
    }
</style>
